import categoryService from "../../../../services/CategoryService"
import Notify from "../../../../elements/Notify"

export default {
   name: 'ProductCategoryForm',
   data() {
      return {
         category: {
            id : null,
            name: '',
            status: true,
         },
         isEdit: false
      }
   },
   created() {
      this.$store.dispatch('title', 'Formulario de categoría de producto')

      // eslint-disable-next-line
      if (!!this.$route.params.categoryId) {
         categoryService.getCategoryById(this.$route.params.categoryId)
            .then((snapshot) => {
               let category         = snapshot.val()

               this.category.id     = category.id
               this.category.name   = category.name
               this.category.status = category.status == '1'

               this.isEdit           = true
            })
            .catch(() => {
               Notify.error("No existe la categoría.")
               this.$router.push({ name: 'categories' })
            })
      }
   },
   methods: {
      saveCategory() {
         if (this.isEdit) {
            this.updateCategory()
         }
         else {
            this.newCategory()
         }
      },
      newCategory() {
         categoryService.storeCategory(this.category)
            .then(() => {
               Notify.success("Se registro una categoría correctamente.")
               this.$router.push({ name: 'categories' })
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      updateCategory() {
         categoryService.updateCategory(this.category)
            .then(() => {
               Notify.success("Se actualizó correctamente.")
               this.$router.push({ name: 'categories' })
            })
            .catch((e) => {
               Notify.error(e)
            })
      }
   },
   computed: {
      statusText() {
         return this.category.status ? 'Disponible' : 'No disponible'
      },
      textButtonSubmit() {
         return this.isEdit ? 'Guardar' : 'Registrar'
      }
   }
}
